import script from "./TicPatientList.vue?vue&type=script&setup=true&lang=js"
export * from "./TicPatientList.vue?vue&type=script&setup=true&lang=js"

import "./TicPatientList.vue?vue&type=style&index=0&id=1e3c21ac&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e3c21ac"]])

export default __exports__